import React from 'react';

import { dispatchLoadEvent } from './metrics';
import { getCustomerFromApi, updateCustomer, normalizeCustomer } from './api';
import { logout } from '../api/customer/login';

import moveToFirstError from '../api/customer/move-to-first-error';

import { moveToNextOrPurchaseFlux, moveToLoginToPurchaseFlux } from '../commons/query';
import InputDate from '../commons/component/input-date';
import InputNumber from '../commons/component/input-number';
import Checkbox from '../commons/component/checkbox';
import { getMaskValue, InputPhone } from '../commons/component/input-mask';
import Input from '../commons/component/input';
import Radio from '../commons/component/radio';
import Error, { hasNamedError } from '../commons/component/error';
import Button from '../commons/component/button';

import teamMembers from '../commons/utils/team-members';
import UserIcon from '../icons/user-icon';
import QuestionMarkIcon from '../icons/question-mark-icon';

const cpfMask = '___.___.___-__';
const telephoneMask = '(__) ____-____';
const cellphoneMask = '(__) _____-____';

class CompletarCadastroComponent extends React.Component {
  state = {
    teamMember: teamMembers(),
    passwordScore: 0,
    showPassword: false,
    isFormSubmitting: false,
    customerAlreadyHasCpf: false,
    customer: {
      email: '',
      cpf: '',
      name: '',
      birthday: '',
      gender: '',
      phone: '',
      cellphone: '',
      offersEmail: 'true',
      receiveWhatsApp: null
    },
    errors: {}
  };

  componentDidMount() {
    dispatchLoadEvent('completeCadastro');
    getCustomerFromApi()
      .then(this.updateCustomerData.bind(this))
      .catch(err => {
        this.setState({ customer: { receiveWhatsApp: false } });
      });
  }

  updateCustomerData(customerApi) {
    if (!customerApi) {
      return;
    }
    const customer = normalizeCustomer(customerApi);
    const customerWithMasks = {
      ...customer,
      // file deepcode ignore CodeInjection: <teste de logout>
      cpf: getMaskValue(cpfMask, customer.cpf),
      phone: getMaskValue(telephoneMask, customer.phone),
      cellphone: getMaskValue(cellphoneMask, customer.cellphone),
      offersEmail: 'true'
    };
    this.setState({ customerAlreadyHasCpf: Boolean(customer.cpf), customer: customerWithMasks });
  }

  async updateCustomer(evt) {
    evt.preventDefault();

    this.setState({ isFormSubmitting: true });
    const { success, errors, customer } = await updateCustomer(
      this.state.customer,
      this.state.customerAlreadyHasCpf
    );

    this.setState({ errors, isFormSubmitting: false });

    if (success) {
      moveToNextOrPurchaseFlux(this.props.history.push);
    } else {
      this.updateCustomerData(customer);
      moveToFirstError(errors);
    }
  }

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  returnToLogin() {
    logout();
    moveToLoginToPurchaseFlux(this.props.history.push);
  }

  changeField(name) {
    return e =>
      this.setState({
        customer: {
          ...this.state.customer,
          [name]: e.target.value
        }
      });
  }

  render() {
    const errors = this.state.errors;

    return (
      <div className="cadastroForm-container">
        <h2 className="cadastroForm-title">
          <UserIcon />
          <span>Complete o cadastro</span>
        </h2>
        <p className="paragraph">
          Falta pouco! Complete seu cadastro abaixo e finalize sua compra.
        </p>

        <form className="cadastroForm" onSubmit={this.updateCustomer.bind(this)}>
          <div className="inputGroup" id="email">
            <label className="inputGroup-label" htmlFor="email-input">
              E-mail
            </label>
            <Input
              placeholder="Ex. joaodasilva@gmail.com"
              className={`inputGroup-input --large ${this.hasError('email')}`}
              data-page="complete-cadastro"
              data-form="complete-cadastro"
              name="email"
              disabled
              value={this.state.customer.email}
              id="email-input"
              type="email"
            />
            <span className="inputGroup-linkAction" onClick={this.returnToLogin.bind(this)}>
              não é você?
            </span>
            <Error errors={errors} name="email" />
          </div>

          <div className="inputGroup --required" id="cpf">
            <label className="inputGroup-label --acronym" htmlFor="cpf-input">
              CPF
            </label>
            <InputNumber
              name="cpf"
              id="cpf-input"
              data-page="complete-cadastro"
              data-form="complete-cadastro"
              onChange={this.changeField('cpf')}
              value={this.state.customer.cpf}
              disabled={this.state.customerAlreadyHasCpf}
              maxLength="11"
              className={`inputGroup-input ${this.hasError('cpf')}`}
              mask={cpfMask}
              placeholder="Ex: 123.456.789-12"
            />
            <Error errors={errors} name="cpf" />
          </div>

          <div className="inputGroup" id="name">
            <label className="inputGroup-label" htmlFor="name-input">
              Seu nome
            </label>
            <Input
              name="name"
              id="name-input"
              onChange={this.changeField('name')}
              value={this.state.customer.name}
              data-page="complete-cadastro"
              data-form="complete-cadastro"
              className={`inputGroup-input --large ${this.hasError('name')}`}
              placeholder={`Ex: ${this.state.teamMember}`}
              type="text"
            />
            <Error errors={errors} name="name" />
          </div>

          <div className="inputGroup" id="birthday">
            <label className="inputGroup-label" htmlFor="birthday-input">
              Data de nascimento
            </label>
            <InputDate
              name="birthday"
              id="birthday-input"
              onChange={this.changeField('birthday')}
              value={this.state.customer.birthday}
              data-form="complete-cadastro"
              data-page="complete-cadastro"
              className={`inputGroup-input ${this.hasError('birthday')}`}
            />
            <Error errors={errors} name="birthday" />
          </div>

          <div className="inputGroup" id="gender">
            <label className="inputGroup-label">Sexo</label>
            <Radio
              className="inputGroup-radio"
              name="gender"
              value="M"
              onClick={this.changeField('gender')}
              checked={this.state.customer.gender === 'M'}
              text="Masculino"
              data-form="complete-cadastro"
              data-page="complete-cadastro"
            />

            <Radio
              className="inputGroup-radio"
              name="gender"
              value="F"
              onClick={this.changeField('gender')}
              checked={this.state.customer.gender === 'F'}
              text="Feminino"
              data-form="complete-cadastro"
              data-page="complete-cadastro"
            />
            <Error errors={errors} name="gender" />
          </div>

          <div className="inputGroup" id="phone">
            <label className="inputGroup-label" htmlFor="phone-input">
              Telefone
            </label>
            <InputPhone
              data-form="complete-cadastro"
              data-page="complete-cadastro"
              onChange={this.changeField('phone')}
              value={this.state.customer.phone}
              name="phone"
              id="phone-input"
              className={`inputGroup-input ${this.hasError('phone')}`}
              type="text"
              placeholder="Ex: (99) 99999-9999"
            />
            <Error errors={errors} name="phone" />
          </div>

          {this.state.customer.receiveWhatsApp !== null && (
            <div className="inputGroup">
              <Checkbox
                className="inputGroup-checkbox"
                name="receiveWhatsApp"
                onChange={this.changeField('receiveWhatsApp')}
                checked={this.state.customer.receiveWhatsApp}
                data-form="signup"
                data-page="signup"
              >
                Receber notificações por Whatsapp.
                <div className="form-tooltip">
                  <div className="form-tooltip__initiator">
                    <QuestionMarkIcon />
                  </div>
                  <div className="form-tooltip__item">
                    Você receberá uma mensagem a cada atualização do seu pedido, desde a confirmação
                    de compra até a entrega.
                  </div>
                </div>
              </Checkbox>
            </div>
          )}

          {this.state.customer.receiveWhatsApp === 'true' && (
            <div className="inputGroup" id="cellphone">
              <label className="inputGroup-label" htmlFor="phone-input">
                Confirme o seu celular
              </label>
              <InputPhone
                data-form="signup"
                data-page="signup"
                onChange={this.changeField('cellphone')}
                value={this.state.customer.cellphone}
                name="phone"
                id="phone-input"
                className={`inputGroup-input ${this.hasError('cellphone')}`}
                type="text"
                placeholder="Ex: (99) 99999-9999"
              />
              <Error errors={errors} name="cellphone" />
            </div>
          )}

          <div className="inputGroup">
            <Checkbox
              className="inputGroup-checkbox"
              name="offersEmail"
              onChange={this.changeField('offersEmail')}
              checked={this.state.customer.offersEmail}
              data-form="complete-cadastro"
              data-page="complete-cadastro"
            >
              Desejo receber ofertas por e-mail
            </Checkbox>
          </div>

          <Button
            primary
            disabled={this.state.isFormSubmitting}
            loading={this.state.isFormSubmitting}
            className="cadastroForm-submit"
          >
            Continuar
          </Button>
        </form>

        <div className="safe-message">Fique tranquilo, nosso site é seguro!</div>
      </div>
    );
  }
}

export default CompletarCadastroComponent;
